// extracted by mini-css-extract-plugin
export default {"productGallery":"MN-z","inQuickShop":"NN-z"};